import { STORE_ORDER_TYPES } from '../constants/storeCheckout.constants';

interface IStoreInfoFormValues {
  orderName: string;
  orderUntil: string;
  storeDescription: string;
  deal: string;
  client: string;
  clientId: string;
  campaign: string;
  hideCampusManagerInfo: boolean;
  charityName: string;
  fundraiserGoal: string;
  displayMadeWithLove: boolean;
}

export interface ILegacyStoreInfoFormShape {
  storeInfo: IStoreInfoFormValues;
}

const PICK_STORE_TYPE_TO_V4: Record<string, string> = {
  'group-order': STORE_ORDER_TYPES.GROUP_ORDER,
  'brand-drop': STORE_ORDER_TYPES.BRAND_DROP,
  fundraiser: STORE_ORDER_TYPES.FUNDRAISER,
  'permanent-store': STORE_ORDER_TYPES.PERMANENT,
};

export const mapPickStoreTypeToV4 = (type: string): string => PICK_STORE_TYPE_TO_V4[type] ?? type;

export const getDefaultLegacyStoreInfoForm = (
  isFieldsDisabled: boolean,
  clientName: string
): ILegacyStoreInfoFormShape => ({
  storeInfo: {
    orderName: isFieldsDisabled ? 'IIT Event 2026' : '',
    orderUntil: isFieldsDisabled ? '2024-12-31' : '',
    storeDescription: isFieldsDisabled
      ? 'Exclusive designs celebrating innovation, culture, and community. Limited-edition apparel made to remember the experience, long after the event ends.'
      : '',
    deal: '',
    client: clientName,
    clientId: '',
    campaign: '',
    hideCampusManagerInfo: false,
    charityName: '',
    fundraiserGoal: '',
    displayMadeWithLove: true,
  },
});

/** Support redis/cache payloads from the flat legacy form shape. */
export const normalizeCachedStoreInfoForm = (
  cached: Record<string, unknown>
): ILegacyStoreInfoFormShape => {
  if (cached.storeInfo && typeof cached.storeInfo === 'object') {
    return { storeInfo: cached.storeInfo as IStoreInfoFormValues };
  }

  return {
    storeInfo: {
      orderName: String(cached.storeName ?? ''),
      orderUntil: String(cached.orderUntil ?? ''),
      storeDescription: String(cached.storeDescription ?? ''),
      deal: String(cached.deal ?? ''),
      client: String(cached.client ?? ''),
      clientId: String(cached.clientId ?? ''),
      campaign: String(cached.campaign ?? ''),
      hideCampusManagerInfo: Boolean(cached.hideCampusManagerInfo ?? false),
      charityName: String(cached.charityName ?? ''),
      fundraiserGoal: String(cached.raiseAmount ?? cached.fundraiserGoal ?? ''),
      displayMadeWithLove: Boolean(cached.displayMadeWith ?? cached.displayMadeWithLove ?? false),
    },
  };
};
